import { Waves, Instagram } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center mb-6">
              <Waves className="h-10 w-10 text-teal-400" />
              <span className="ml-3 text-2xl font-bold">In Deep Water</span>
            </div>
            <p className="text-gray-400 text-lg">
              Building a sustainable future for our coastal ecosystems
            </p>
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-6">Contact</h3>
            <p className="text-gray-400 text-lg mb-3">rdflab@fiu.edu</p>
            
          </div>
          <div>
            <h3 className="text-xl font-semibold mb-6">Follow Us</h3>
            <div className="flex space-x-6">
              <a
                href="https://www.instagram.com/rdflabfiu/"
                target="_blank"
                className="text-gray-400 hover:text-teal-400 transition-colors"
              >
                <Instagram className="h-8 w-8" />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-12 border-t border-gray-800 text-center text-gray-400">
          <p className="text-lg">
            © {new Date().getFullYear()} In Deep Water. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
} 